export default __webpack_public_path__ + "static/media/G0003.e10721d6.png";